module.exports = __webpack_public_path__ + "img/xmasParty9.05be420e.jpg";